/**
 * @desc: - 换肤弹窗
 * @param  {[FUNCTION]} : hideSkinningModal [关闭换肤弹窗]
 * @param  {[BLOON]} ：displaySkinning  [是否显示换肤弹窗] 
 * @param  {[STRING]} fatherClass  [最外层div的class] 
 * @param  {[FUNCTION]} changSkin  [改变最外层DIV的函数] 

 * @author: Circle
 */
import ReactDOM from 'react-dom'
import React from 'react'
import * as UNIT from '../../helpers/unit.js';
export default class Skinning extends React.Component {
 	constructor(props){
 		super(props)
 		this.hideSkinningModal = this.hideSkinningModal.bind(this);
 		this.saveSkin = this.saveSkin.bind(this);
 		this.restoreSkin = this.restoreSkin.bind(this);
 		this.skins = [
 			{ className: 'sc-background-01', title: '默认'},
 			{ className: 'sc-background-02', title: '云樱'},
 			{ className: 'sc-background-03', title: '春桃'},
 			{ className: 'sc-background-04', title: '都市'},
 			{ className: 'sc-background-05', title: '歌剧魅影'},
 			{ className: 'sc-background-06', title: '梦幻'},
 			{ className: 'sc-background-07', title: '魔境'},
 			{ className: 'sc-background-08', title: '蔚蓝'},
 			{ className: 'sc-background-09', title: '午夜'},
 			{ className: 'sc-background-10', title: '足球宝贝'}

 		]
 		let {fatherClass} = this.props 
 	}
 	skinning(val){
 		this.props.changSkin(val)

 	}
 	
	componentWillReceiveProps(nextProps){
		if (nextProps.displaySkinning && !this.props.displaySkinning) {
			this.skin = nextProps.fatherClass;
		}
	}

	//取消，关闭
	hideSkinningModal(){
		let {hideSkinningModal, changSkin} = this.props
		hideSkinningModal();
		changSkin(this.skin);
	}
	
	//保存设置
	saveSkin(){
		let {fatherClass, changSkin, hideSkinningModal} = this.props 
		UNIT.setCookie("skin",fatherClass, 7*24*3600);
		changSkin(fatherClass);
		hideSkinningModal();
	}
	//恢复默认
	restoreSkin(){
		let {hideSkinningModal, changSkin} = this.props
		hideSkinningModal();
		changSkin("sc-background-01");
		UNIT.setCookie("skin","sc-background-01", 7*24*3600);
	}

	render(){
		let {displaySkinning, fatherClass, changSkin} = this.props
		let displayStayle = {
			display:displaySkinning==true?"block":"none"
		}
		return(
			<div className="skin-box" style={displayStayle}>
			    <span className="close_box" onClick = {this.hideSkinningModal}></span>
			    <div className="skin_tit"><i></i>更换背景</div>
			    <div className="skin_main">
			        <div className="skin_div">
				        <ul className="skin_ulbox clerafix" ref = "skinBtn">
				           {
				           	this.skins.map((item, index) => 
				           		<li key= {index} className={'samll_' + item.className}><a href="javascript:void(0);" className ={fatherClass==item.className?"active":""} onClick={changSkin.bind(this, item.className)}></a><span>{item.title}</span></li>
				           	)
				           }
			       		</ul>
			        </div>
			        <div className="skin_page">
			        	<a href="javascript:void(0);" className="btn_default" onClick = {this.restoreSkin}><i className="ic-hfmr"></i>恢复默认</a>
			        	<a href="javascript:void(0);" className="btn_cancel" onClick = {this.hideSkinningModal}>取 消</a>
			        	<a href="javascript:void(0);" className="btn_set" onClick = {this.saveSkin}><i className="ic-bcsz"></i>保存设置</a>
			        </div>
			    </div>
			</div>
		)
	}
 }
